export const HubNames = {
  GENERAL: "/General",
  USER_MANGEMENT: "/UserManagement",
  FACILITY_MANAGEMENT: "/FacilityManagement",
};
